module.exports = __webpack_public_path__ + "img/bofang-bg.f085a008.jpg";